import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";

import createRegulatorPortalInstance from "../../../api/RegulatorPortalInstance";
import {
  parseReportingRunList,
  type ReportingRun,
} from "./parseReportingRuns";
import {
  buildReportingRunsPath,
  type ReportingRunListOrder,
} from "./reportingPaths";

export const REPORTING_RUNS_LIST_QUERY_KEY = [
  "regulator-portal",
  "reporting-runs",
] as const;

export const reportingRunsListQueryKey = (order: ReportingRunListOrder) =>
  [...REPORTING_RUNS_LIST_QUERY_KEY, order] as const;

export const fetchReportingRuns = async (
  order: ReportingRunListOrder = "desc",
): Promise<ReportingRun[]> => {
  const response = await createRegulatorPortalInstance().get(
    buildReportingRunsPath(order),
  );
  return parseReportingRunList(response.data);
};

export const useReportingRuns = (
  order: ReportingRunListOrder = "desc",
): UseQueryResult<ReportingRun[], Error> =>
  useQuery<ReportingRun[], Error>({
    queryKey: reportingRunsListQueryKey(order),
    queryFn: () => fetchReportingRuns(order),
    staleTime: 1000 * 30,
    refetchOnWindowFocus: false,
    retry: false,
  });
